import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'dpl/common/components/Icon';

export default function MoreImagesCount({ count }) {
  return (
    <div className="MoreImagesCount pv1 ph2 inline-flex font-12 bg-dark-transparent br-pill white items-center">
      <div className="dn db-ns">
        <Icon name="fetch-camera" width="16px" height="16px" className="mr1" />
      </div>
      <span className="dn-ns">+</span>
      <span className="font-12">{count}</span>
    </div>
  );
}

MoreImagesCount.propTypes = {
  count: PropTypes.number.isRequired
};
